export enum PtDetailsMode {
	READ = "READ",
	UPDATE = "UPDATE",
}
